<template>
  <div class="campaign-period-container">
    <strong class="text-cinza-d10" style="font-size: 16px">Lojas participantes</strong>
    <div class="offer-calendar-container">
      <div class="mt-4 validity-period">
        <div class="input-container">
          <v-skeleton-loader v-if="loadingAction" height="40" width="221" type="button" />
          <mf-select-units-dialog
            v-else
            dense
            outlined
            label=""
            :disabled="disableFields"
            :selected-units.sync="selectedUnits"
            :selected-units-configuration.sync="selectedUnitsConfiguration"
            hide-ecommerce-configuration
            :unit-error="unitError"
            :maria-campaign="campaign"
            :units="allUnits"
            :tag-list="tagList"
            :group-list="unitsGroups"
            :default-data-type="defaultDataType"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mariaCampaign } from '@/modules/maria/campanha-da-maria-v2/mixins/maria-campaign'

export default {
  name: 'SelectUnits',
  mixins: [mariaCampaign],
  props: {
    disableFields: {
      type: Boolean,
      default: false,
    },
    defaultDataType: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    unitError: false,
  }),
  computed: {
    ...mapGetters(['tagList', 'campaignDays', 'unitsGroups']),
    selectedUnits: {
      get() {
        return Array.isArray(this.campaign?.units) ? this.campaign.units : []
      },
      set(value) {
        this.setOmniCampaignKey({ key: 'units', payload: value })
      },
    },
    selectedUnitsConfiguration: {
      get() {
        return this.campaign.units_configuration
      },
      set(value) {
        this.setOmniCampaignKey({ key: 'units_configuration', payload: value })
      },
    },
    allUnits() {
      if (this.campaignHasOffers) {
        return this.$store.getters.units.filter((unit) => this.unitsFromOfferSchedules.includes(unit.id_erp))
      }
      return this.$store.getters.units
    },
  },
  watch: {
    selectedUnits: {
      handler(value) {
        if (value.length) {
          this.unitError = false
        }
      },
      deep: true,
    },
  },
  methods: {
    validate() {
      this.unitError = false
      let isValid = true
      if (!this.selectedUnits.length) {
        this.unitError = true
        isValid = false
      }

      return isValid
    },
  },
}
</script>

<style lang="scss" scoped>
.campaign-period-container {
  .text-cinza-d10 {
    color: $cinza-d10;
  }

  .info-card-container {
    max-width: 735px;
  }

  .offer-calendar-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;

    .validity-period {
      display: flex;
      align-items: flex-start;
      gap: 20px;

      .input-container {
        max-width: 240px;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }

    .legend-container {
      display: flex;
      flex-direction: column;
      gap: 4px;
      min-width: 158px;

      .legend-item {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.4000000059604645px;

        .legend-icon {
          width: 12px;
          height: 12px;
          border-radius: 4px;
        }

        .legend-text {
          color: $cinza-l10;
        }
      }
    }

    .text-cinza-l20 {
      color: $cinza-l20;
    }

    ::v-deep .v-skeleton-loader {
      .v-skeleton-loader__button,
      .v-skeleton-loader__heading {
        width: auto !important;
      }
    }
  }
}
</style>
